import React from 'react';
import Appearance from '../../Page/Frst Appearance';
import SpecialOffer from '../../Page/Special Offer/index';
import Choose from '../../Page/Why Choose/index';
import Calculator from '../../Page/Cost Calculator';
import Ourwork from '../../Page/Our Work';
import TurnkeyWorks from '../../Page/Turnkey Works';
import WindowProfiles from '../../Page/Window Profiles/index';
import WindowAccessories from '../../Page/Window Accessories';
import CustomersSay from '../../Page/Customers Say';
import PaymentConvenient from '../../Page/Payment Convenient';
import FAQ from '../../Page/FAQ';
import MapsAndContacts from '../../Page/Our Contacts';
export default function Window() {
  return (
    <>
      <Appearance />
      <SpecialOffer />
      <Choose />
      <Calculator />
      <Ourwork />
      <TurnkeyWorks />
      <WindowProfiles />
      <WindowAccessories />
      <CustomersSay />
      <PaymentConvenient />
      <FAQ />
      <MapsAndContacts />
    </>
  )
}
